AgrimarketServices.service('numberService', [
    function() {
        this.getNbDecimal = function(value) {
            if (value === null || value === undefined || !isFinite(value)) return 0;
            var text = value.toString();
            if (text.indexOf('e-') !== -1) {
                var parts = text.split('e-');
                return (parts[0].split('.')[1] || '').length + parseInt(parts[1], 10);
            }
            var decimalPart = text.split('.')[1];
            return decimalPart ? decimalPart.length : 0;
        };
    }
]);